import styled from 'styled-components'

const MyDiv = styled.div`
.flex_header{
    align-items: center;
    justify-content: space-between;
}
.btn {
  background-color: #006838;
  color: white;
  border-radius: 6px;
  padding: 8px 8px;
  &:hover {
    background-color: #006838;
    color: white;
  }
}

.overview_card {
  border-radius: 10px;
  padding: 12px;
  margin-top: 10px;
}
.green {
  background-color: #D0FAE6;
}
.orange {
  background-color:#FFEED4;
}

.react-calendar {
    font-family: 'Poppins', sans-serif;   
    width: 220px;
    max-width: 100%;
    font-size: 12px;
    border: none;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  }

  .react-calendar__tile {
    padding: 6px 0;
  }

  .react-calendar__navigation button {
    min-width: 28px;
    font-size: 12px;
  }

  .react-calendar__month-view__days__day--weekend {
    color: #ff6b6b;
  }
`
export default MyDiv
